/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _7 = memo(() => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>Домашняя работа</h2>
    </section>
  )
})
